"use client";

import { useEffect } from "react";

interface GTMEventTrackerProps {
    event: string;
    data?: Record<string, any>;
}

const GTMEventTracker: React.FC<GTMEventTrackerProps> = ({ event, data }) => {
    useEffect(() => {
        if (typeof window !== "undefined") {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event,
                ...data,
            });
        }
    }, [event, data]);

    return null;
};

export default GTMEventTracker;
